export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

const navigationConfig = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: { icon: 'vuestic-iconset-dashboard' },
    },
    {
      name: 'Super Admin',
      displayName: 'Super Admin',
      meta: { icon: 'admin_panel_settings' },
      children: [{ name: 'menus', displayName: 'Menus', meta: { icon: 'menu' } }],
    },
  ] as INavigationRoute[],
}

export default navigationConfig
